export type PaginationRangeItem = number | 'ellipsis';

/**
 * Builds the list of page buttons to render, centering a sliding window on the current page.
 *
 * @param currentPage - Active page, 1-based.
 * @param totalPages - Total number of pages.
 * @param maxVisiblePages - Maximum numbered pages to show. Omit to show every page.
 * @returns Page numbers with `'ellipsis'` markers where pages are hidden.
 */
export function getPaginationRange(currentPage: number, totalPages: number, maxVisiblePages?: number): PaginationRangeItem[] {
    const allPages = Array.from({ length: Math.max(0, totalPages) }, (_, index) => index + 1);

    if (!maxVisiblePages || maxVisiblePages < 1 || allPages.length <= maxVisiblePages) {
        return allPages;
    }

    const lastWindowStart = totalPages - maxVisiblePages + 1;
    const windowStart = Math.min(Math.max(1, currentPage - Math.floor(maxVisiblePages / 2)), lastWindowStart);
    const windowEnd = windowStart + maxVisiblePages - 1;

    const range: PaginationRangeItem[] = allPages.slice(windowStart - 1, windowEnd);

    if (windowStart > 1) {
        range.unshift('ellipsis');
    }
    if (windowEnd < totalPages) {
        range.push('ellipsis');
    }

    return range;
}
